import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  signOut: { id: "sideMenu.signOut", defaultMessage: "Sign out" }
});
